<script lang="ts">
  import type { Snippet } from "svelte";
  import type { ClassValue } from "svelte/elements";

  interface Props {
    children: Snippet;
    active: boolean;
    class?: ClassValue;
  }

  let { children, active, class: className }: Props = $props();
</script>

<div
  class={[
    "w-full max-w-[1100px] self-center leading-[40px] text-center inline gap-3 px-4 py-2 rounded-sm border border-almanac-dark-green/30 bg-[#F4F4F4]/60 items-baseline shadow-md",
    active ? "active-shadow" : "inactive-shadow",
    "container",
    className,
  ]}
>
  {@render children?.()}
</div>

<style lang="postcss">
  .active-shadow {
    box-shadow:
      0 4px 12px rgba(23, 69, 12, 0.08),
      0 0 0 1px rgba(23, 69, 12, 0.03);

    transition: box-shadow 0.3s ease;
  }

  .active-shadow:hover {
    box-shadow:
      0 4px 12px rgba(23, 69, 12, 0.2),
      0 0 0 1px rgba(23, 69, 12, 0.06);
  }

  .inactive-shadow {
    box-shadow: 0px 2px 6px 0px rgba(23, 69, 12, 0.2);
  }

  .container > :global(span:not(:last-child)) {
    @apply pr-1;
  }
  .container > :global(span:not(:first-child)) {
    @apply pl-1;
  }
</style>
